import React from 'react';
import { optionsOf } from '../../drift/tableModel';

const ARROW = { asc: '▲', desc: '▼' };

// The header rows of a sortable, filterable table: one row of column names (click one to sort: ascending, descending, back to the original
// order) and one row of filters under them (text that the cell contains, or a list of the values for a column with few). Use inside <thead>.
//   view   from useTableView
//   lead   the number of empty columns in front (the caret of an open-in-place table)
//   tail   the number of empty columns after (tailWidth: how wide each is, 28 by default)
//   select { checked, indeterminate, onChange, label }: a checkbox column after the lead, to select every row shown
export default function ColumnHeads({ view, lead = 0, tail = 0, tailWidth = 28, select = null }) {
  const { columns, sort, filters } = view;
  const blanks = (n, name, width = 28) => Array.from({ length: n }, (_, i) => <th key={`${name}${i}`} style={{ width }} aria-hidden="true" />);
  return (
    <>
      <tr>
        {blanks(lead, 'a')}
        {select && <th style={{ width: 28 }}><input type="checkbox" aria-label={select.label || 'Select all shown'} checked={select.checked} ref={(el) => { if (el) el.indeterminate = !!select.indeterminate; }} onChange={select.onChange} /></th>}
        {columns.map((c) => {
          const dir = sort && sort.key === c.key ? sort.dir : null;
          return (
            <th key={c.key} aria-sort={dir === 'asc' ? 'ascending' : dir === 'desc' ? 'descending' : 'none'} className={c.className}>
              <button type="button" className="sort" onClick={() => view.toggleSort(c.key)} title={`Sort by ${c.label}`}>
                {c.label}<span className="sort-arrow" aria-hidden="true">{dir ? ARROW[dir] : ''}</span>
              </button>
            </th>
          );
        })}
        {blanks(tail, 'b', tailWidth)}
      </tr>
      <tr className="filters">
        {blanks(lead, 'c')}
        {select && <th aria-hidden="true" />}
        {columns.map((c) => (
          <th key={c.key}>
            {c.options ? (
              <select aria-label={`Filter ${c.label}`} value={filters[c.key] || ''} onChange={(e) => view.setFilter(c.key, e.target.value)}>
                <option value="">All</option>
                {optionsOf(view.all, c).map((o) => <option key={o} value={o}>{o}</option>)}
              </select>
            ) : (
              <input type="search" aria-label={`Filter ${c.label}`} value={filters[c.key] || ''} placeholder="filter" onChange={(e) => view.setFilter(c.key, e.target.value)} />
            )}
          </th>
        ))}
        {blanks(tail, 'd', tailWidth)}
      </tr>
    </>
  );
}
